import { render, staticRenderFns } from "./DialogUploadVideo.vue?vue&type=template&id=21f8daae&scoped=true"
import script from "./DialogUploadVideo.vue?vue&type=script&lang=js"
export * from "./DialogUploadVideo.vue?vue&type=script&lang=js"
import style0 from "./DialogUploadVideo.vue?vue&type=style&index=0&id=21f8daae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f8daae",
  null
  
)

export default component.exports